import { CommonModule, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { VideoComponent } from '../video-block/components/video/video.component';
import { ContentCardComponent } from './content-card/content-card.component';
import { FormComponent } from './form/form.component';
import { FormBlockConfiguration } from './models/form-block.models';

@Component({
    selector: 'nw-form-block',
    imports: [
        FormComponent,
        NgTemplateOutlet,
        CommonModule,
        ContentCardComponent,
        VideoComponent,
        NgOptimizedImage
    ],
    templateUrl: './form-block.component.html',
    styleUrls: ['./form-block.component.scss']
})
export class FormBlockComponent implements OnChanges {
    @Input() lefthandcontent!: FormBlockConfiguration.BlockList[];
    @Input() righthandcontent!: FormBlockConfiguration.BlockList[];
    @Input() theme: string = 'light';

    ngOnChanges() {
        if (typeof this.lefthandcontent === 'string') {
            this.lefthandcontent = JSON.parse(this.lefthandcontent);
        }

        if (typeof this.righthandcontent === 'string') {
            this.righthandcontent = JSON.parse(this.righthandcontent);
        }
    }
}
